import React from 'react';
import { Box, Typography } from '@mui/material';
import { displayValue, firstAvailable, isBlank, latestEntry } from '../utils';

const Settings = {
  Name: 'Battery',
  Display: true,
  document: {
    url: '/widgets/battery',
    label: 'Battery Document',
  },
  options: {
    view: null,
    settings: [
      { id: 'label', type: 'text', name: 'Label', default: 'Battery' },
      { id: 'dataId', type: 'text', name: 'Data path', placeholder: 'battery or body.battery' },
      { id: 'units', type: 'text', name: 'Units', default: '%' },
      { id: 'emptyText', type: 'text', name: 'Empty text', default: 'Unknown' },
    ],
    grid: true,
  },
};

const BATTERY_PATHS = [
  'battery',
  'Battery',
  'body.battery',
  'body.Battery',
  'headers.battery',
  'headers.Battery',
];

const View = ({ DeviceData, Settings: userSettings = {} }) => {
  const entry = latestEntry(DeviceData);
  const paths = userSettings.dataId ? [userSettings.dataId, ...BATTERY_PATHS] : BATTERY_PATHS;
  const value = firstAvailable(entry, paths);
  const emptyText = userSettings.emptyText || 'Unknown';
  const label = userSettings.label || 'Battery';
  const units = isBlank(value) ? '' : userSettings.units ?? '%';

  return (
    <Box>
      {label ? <Typography component="strong" sx={{ fontWeight: 700 }}>{label}: </Typography> : null}
      <Typography component="span">
        {displayValue(value, emptyText)}{units ? ` ${units}` : ''}
      </Typography>
    </Box>
  );
};

export default {
  Settings,
  View,
};
